import Button from "@/common/components/Button";
import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import Skeleton from "@/common/components/Skeleton";
import TextArea from "@/common/components/TextArea";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { UserRoundIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface CreatorSectionProps {
  establishmentCompany?: EstablishmentCompanyData;
  isEstablishmentPending?: boolean;
}

const CreatorSection = ({ establishmentCompany, isEstablishmentPending }: CreatorSectionProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-bold">
          Responsáveis internos
        </p>

        <Button name="edit" operationKlassToCheckPermission="Admin::Establishment::Companies::Update" onClick={() => navigate('edit')}>
          Editar
        </Button>
      </div>

      <div className="flex items-start gap-x-4">
        <div className="flex flex-col gap-y-1">
          <p className="text-xs">Responsável interno</p>

          {isEstablishmentPending ? (
            <div className="flex gap-2 items-center">
              <Skeleton className="rounded-full size-8" />

              <Skeleton className="h-5 w-40" />
            </div>
          ) : (
            <div className="flex gap-2 items-center">
              <ImageWithPlaceholder
                url={establishmentCompany?.commercial_manager?.profile_picture?.url}
                alt={establishmentCompany?.commercial_manager?.full_name}
                className="size-8"
                iconClassName="size-6"
                placeholderIcon={UserRoundIcon}
              />

              <p className="font-bold text-sm">
                {establishmentCompany?.commercial_manager.full_name}
              </p>
            </div>
          )}
        </div>

        <div className="flex flex-col gap-y-1">
          <p className="text-xs">Responsável interno substituto</p>

          {isEstablishmentPending ? (
            <div className="flex gap-2 items-center">
              <Skeleton className="rounded-full size-8" />

              <Skeleton className="h-5 w-40" />
            </div>
          ) : (
            <div className="flex gap-2 items-center">
              <ImageWithPlaceholder
                url={establishmentCompany?.commercial_manager_substitute?.profile_picture?.url || ''}
                alt={
                  establishmentCompany?.commercial_manager_substitute?.full_name
                    ? establishmentCompany?.commercial_manager_substitute?.full_name
                    : ''
                }
                className="size-8"
                iconClassName="size-6"
                placeholderIcon={UserRoundIcon}
              />

              <p className="font-bold text-sm">
                {establishmentCompany?.commercial_manager_substitute?.full_name
                  ? establishmentCompany?.commercial_manager_substitute?.full_name
                  : '--'}
              </p>
            </div>
          )}
        </div>
      </div>

      <TextArea
        disabled
        value={establishmentCompany?.observations || ""}
        rows={5}
      />
    </div>
  );
};

export default CreatorSection;
